<template>
  <div class="control" :class="{'false': !currValue, 'true': currValue}">
    <div class="togglebutton"></div>
  </div>
</template>

<script>
export default {
  props: {
    currValue: Boolean,
  }
};
</script>
<style scoped>
.control {
  height: 15px;
  width: 30px;
  background-color: #DDD;
  border-radius: 7px;
  position: relative;
  cursor: pointer;
  margin: 10px;
}
.control .togglebutton {
  position: absolute;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: left 0.2s, background-color 0.2s;
}

.control.true .togglebutton {
  background-color: #ed1c24;
  left: 100%;
}

.control.false .togglebutton {
  background-color: #999;
  left: 0;
}
</style>
